import { Routes } from '@angular/router';

import { ErrorComponent } from '@features/loan/components/error/error.component';
import { RoutesPath } from '@features/loan/enums/routes.enum';
import { loanResolver } from '@features/loan/resolvers';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./features/loan/components/loan-selection/loan-selection.component').then(
        (m) => m.LoanSelectionComponent,
      ),
    resolve: { resolver: loanResolver },
  },
  {
    path: RoutesPath.Contact,
    loadComponent: () =>
      import('./features/loan/components/contact/contact.component').then(
        (m) => m.ContactComponent,
      ),
  },
  {
    path: RoutesPath.SimulationResult,
    loadComponent: () =>
      import('./features/loan/components/simulation-result/simulation-result.component').then(
        (m) => m.SimulationResultComponent,
      ),
  },
  {
    path: RoutesPath.BorrowerSelection,
    loadComponent: () =>
      import('./features/loan/components/borrower-selection/borrower-selection.component').then(
        (m) => m.BorrowerSelectionComponent,
      ),
  },
  {
    path: RoutesPath.Error,
    component: ErrorComponent,
  },
];
